import { Key } from '@/enums/key';
import { EShortcutGroup } from '@shared/dto/hint_shortcuts/e_shortcut_group';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { IHintShortcutData } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data';
import { useMemo } from 'react';
import { HOOK_WORKSPACE__get_list_sorted } from '../workspace/HOOK_WORKSPACE__get_list_sorted';
import { create_data_row } from './use_hints_shortcuts_data';

export function use_hints_shortcut_workspace_navigation(): IHintShortcutData {
  const workspaces_list_sorted = HOOK_WORKSPACE__get_list_sorted();

  let data_rows = useMemo(() => {
    let out = [];

    for (let [index, workspace] of workspaces_list_sorted.entries()) {
      let keyboard_key = get_keyboard_key(index);

      if (keyboard_key.is_blank()) continue;

      let data_row = create_data_row(workspace.name, [keyboard_key]);

      out.push(data_row);
    }

    return out;
  }, [workspaces_list_sorted]);

  /*
   * METHODS
   */

  function get_keyboard_key(index: number) {
    let position = index + 1;

    if (position == 10) return Key.Number0;
    if (position > 10) return '';

    return position.toString();
  }

  return { data_rows, key: EShortcutType.NAVIGATION_HOTKEYS_BETWEEN_WORKSPACES, keys_have_same_animation_delay: false, group: EShortcutGroup.NAVIGATION };
}
